import React, { useState } from 'react';

import NumberInput from 'fantastic/components/common/NumberInput';

const SingleNumberSetting = (props) => {
  const onChange = (value) => {
    const { onChange, param: { field } } = props;
    onChange(field, value);
  };

  const label = props.label || i18n.t('size');
  return (
    <div className="form-group">
      <label>{label}</label>
      <NumberInput value={props.param.value} onChange={onChange} />
    </div>
  );
};

export default SingleNumberSetting;
